import { Layout } from '@pixleeturnto/wr4pt';
import styled from 'styled-components';

export const Loader = styled.div`
  font-size: 12px;
  text-align: center;
  ${Layout}
`;
